import { render, staticRenderFns } from "./OfficialStatSection.vue?vue&type=template&id=35a792c7&scoped=true&"
import script from "./OfficialStatSection.vue?vue&type=script&lang=js&"
export * from "./OfficialStatSection.vue?vue&type=script&lang=js&"
import style0 from "./OfficialStatSection.vue?vue&type=style&index=0&id=35a792c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a792c7",
  null
  
)

export default component.exports